import axios from "axios";
import { dkeysInfoBaseURL, l2BaseURL } from "config/config";

// Базовые конфигурации axios
const createApiClient = (baseURL, defaultHeaders = {}) => {
  return axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      ...defaultHeaders,
    },
  });
};

const server_dkeysInfo = createApiClient(dkeysInfoBaseURL, {
  "Content-Type": "application/json",
});

const l2 = createApiClient(l2BaseURL);

// Вспомогательные функции
export const getAccept = () => {
  const randomValues = Array.from({ length: 10 }, () => Math.floor(Math.random() * 101));
  return `${window.location.search.slice(1)}|${randomValues.join("")}`;
};

const handleApiError = (error, defaultMessage = "Oops, some unforeseen errors :(") => {
  console.error(error);
  const message =
    error?.response?.data?.message ||
    error?.message ||
    defaultMessage;
  return {
    DATA: null,
    error: true,
    message,
  };
};

const guessImageMime = (bytes = []) => {
  if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) {
    return "image/png";
  }
  if (bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46) {
    return "image/gif";
  }
  return "image/jpeg";
};

const bytesToBase64 = (bytes = []) => {
  if (!Array.isArray(bytes) || !bytes.length) {
    return null;
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(bytes).toString("base64");
  }
  if (typeof window !== "undefined" && typeof window.btoa === "function") {
    let binary = "";
    bytes.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });
    return window.btoa(binary);
  }
  return null;
};

export const normalizeArticleBlocks = (payload) => {
  if (!payload || !Array.isArray(payload.DATA)) {
    return payload;
  }

  const normalizedBlocks = payload.DATA.map((block) => {
    if (!block?.image || typeof block.image === "string") {
      return block;
    }

    if (block.image?.type === "Buffer" && Array.isArray(block.image?.data)) {
      const base64 = bytesToBase64(block.image.data);
      if (!base64) {
        return block;
      }
      const mime = guessImageMime(block.image.data);
      return {
        ...block,
        image: `data:${mime};base64,${base64}`,
      };
    }

    return block;
  });

  return {
    ...payload,
    DATA: normalizedBlocks,
  };
};

export const collapseDataArray = (payload) => {
  if (!payload || !Array.isArray(payload.DATA)) {
    return payload;
  }
  return {
    ...payload,
    DATA: payload.DATA[0] ?? null,
  };
};

// Базовые API методы
const resolvePostArguments = (pathOrData, maybeData, maybeConfig) => {
  if (typeof pathOrData === "string" && pathOrData.startsWith("/")) {
    return {
      path: pathOrData,
      data: maybeData,
      config: maybeConfig || {},
    };
  }

  return {
    path: "",
    data: pathOrData,
    config: maybeData || {},
  };
};

const createApiMethods = (apiClient) => ({
  async post(pathOrData = "", maybeData, maybeConfig) {
    const { path, data, config } = resolvePostArguments(pathOrData, maybeData, maybeConfig);
    try {
      const response = await apiClient.post(path, data, config);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  },

  async postFormData(data, url, config = {}) {
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        ...config,
      });

      if (!response.data.success) {
        throw new Error(response.data.message || `Operation failed`);
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },
});

export const dkeysApi = createApiMethods(server_dkeysInfo);
const l2Api = createApiMethods(l2);

// API группы
export const openLink = {
  async getOpenLinkData(link) {
    const response = await dkeysApi.post("/linkOpen", { link });
    return collapseDataArray(response);
  },

  async openDoor(link) {
    const data = { link };
    const config = {
      headers: {
        "Content-Type": "text/plain; charset=utf-8; application/json",
      },
    };
    return await l2Api.post(data, config);
  },

  async addOpenLink(link, dt_close) {
    return await dkeysApi.post("/addOpenLink", { link, dt_close });
  },

  async deleteOpenLink(link) {
    return await dkeysApi.post("/delOpenLink", { link });
  },

  async getOpenLinkPush(link) {
    const response = await dkeysApi.post("/linkOpenPush", { link });
    return collapseDataArray(response);
  },
};

export const articleCodeMP = {
  async getArticle(codeMP) {
    const result = await dkeysApi.post("/getDataByCodeMP", { codeMP });
    if (result.error) {
      result.message = "Опаньки, какие-то не предвиденные ошибки :(";
    }
    return normalizeArticleBlocks(result);
  },
};
